import React from 'react';
export const CandleFlame = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 40" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-353" data-mp="iq1ftzyaifmh">
    {/* Candle Body */}
    <rect x="8" y="20" width="8" height="20" rx="1" fill="#FAEDE3" stroke="#C9A961" strokeWidth="1" data-id="element-354" data-mp="rpoisq6o3thn" />
    <path d="M8 22 Q12 24 16 22" stroke="#C9A961" strokeWidth="0.5" fill="none" data-id="element-355" data-mp="16eknqedfgqe1" />
    {/* Wick */}
    <line x1="12" y1="18" x2="12" y2="20" stroke="#6B4423" strokeWidth="1" data-id="element-356" data-mp="11fhtloyzk4ku" />
    {/* Flame */}
    <path d="M12 4 C12 4 8 12 8 16 C8 18.2 9.8 20 12 20 C14.2 20 16 18.2 16 16 C16 12 12 4 12 4 Z" fill="#C9A961" className="animate-candle" data-id="element-357" data-mp="1ffagf97e60nj" />
    <path d="M12 8 C12 8 10 13 10 16 C10 17.1 10.9 18 12 18 C13.1 18 14 17.1 14 16 C14 13 12 8 12 8 Z" fill="#E8A795" className="animate-candle" style={{
    animationDelay: '0.1s'
  }} data-id="element-358" data-mp="1ah8zouxfudf8" />
  </svg>;
export const OpenJournal = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 48 36" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-359" data-mp="3oav6ihx1dg35">
    {/* Left Page */}
    <path d="M24 32 C24 32 16 34 4 30 L4 6 C16 10 24 8 24 8 Z" fill="#FAEDE3" stroke="#6B4423" strokeWidth="1.5" strokeLinejoin="round" data-id="element-360" data-mp="22dedmkprnfs" />
    {/* Right Page */}
    <path d="M24 32 C24 32 32 34 44 30 L44 6 C32 10 24 8 24 8 Z" fill="#FAEDE3" stroke="#6B4423" strokeWidth="1.5" strokeLinejoin="round" data-id="element-361" data-mp="6u4xxd5gcswf" />
    {/* Center Binding */}
    <line x1="24" y1="8" x2="24" y2="32" stroke="#6B4423" strokeWidth="1.5" data-id="element-362" data-mp="fsgxi4oar110" />
    {/* Lines Left */}
    <line x1="8" y1="14" x2="20" y2="12" stroke="#C9A961" strokeWidth="1" strokeOpacity="0.5" data-id="element-363" data-mp="ktmrs6xluwcn" />
    <line x1="8" y1="18" x2="20" y2="16" stroke="#C9A961" strokeWidth="1" strokeOpacity="0.5" data-id="element-364" data-mp="pqmymk2a434t" />
    <line x1="8" y1="22" x2="16" y2="20" stroke="#C9A961" strokeWidth="1" strokeOpacity="0.5" data-id="element-365" data-mp="2mkzucpc3os5j" />
    {/* Lines Right */}
    <line x1="28" y1="12" x2="40" y2="14" stroke="#C9A961" strokeWidth="1" strokeOpacity="0.5" data-id="element-366" data-mp="2rjkukorcrbtz" />
    <line x1="28" y1="16" x2="40" y2="18" stroke="#C9A961" strokeWidth="1" strokeOpacity="0.5" data-id="element-367" data-mp="2jivcqluiaw19" />
    <line x1="28" y1="20" x2="36" y2="22" stroke="#C9A961" strokeWidth="1" strokeOpacity="0.5" data-id="element-368" data-mp="2ekjzs28x05et" />
    {/* Feather Pen */}
    <path d="M36 28 L46 16 C46 16 44 10 40 12 C36 14 36 28 36 28 Z" fill="#C2614F" opacity="0.8" data-id="element-369" data-mp="2teg84152ky21" />
    <line x1="36" y1="28" x2="42" y2="15" stroke="#FAEDE3" strokeWidth="0.5" data-id="element-370" data-mp="2ojj1t1z6d2su" />
  </svg>;
export const SacredCircle = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 60 60" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-371" data-mp="2xg1se7jxoem9">
    <circle cx="30" cy="30" r="28" stroke="#C9A961" strokeWidth="1" strokeDasharray="4 4" className="animate-[spin_20s_linear_infinite]" data-id="element-372" data-mp="3787fp3z8q7v4" />
    <circle cx="30" cy="30" r="22" stroke="#6B4423" strokeWidth="0.5" data-id="element-373" data-mp="3l8i8ick41wix" />
    <path d="M30 8 L30 52 M8 30 L52 30 M14.5 14.5 L45.5 45.5 M14.5 45.5 L45.5 14.5" stroke="#C9A961" strokeWidth="0.5" strokeOpacity="0.5" data-id="element-374" data-mp="3h6wrcf0jmw2x" />
    <circle cx="30" cy="30" r="12" fill="rgba(194, 97, 79, 0.1)" stroke="#6B4423" strokeWidth="1" data-id="element-375" data-mp="3pt67a0enovt" />
    <circle cx="30" cy="30" r="4" fill="#C9A961" data-id="element-376" data-mp="8nbi999pyk81" />
  </svg>;
export const TearDrop = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 32" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-377" data-mp="3vrhmjxszi88i">
    <path d="M12 2 C12 2 4 14 4 20 C4 24.4 7.6 28 12 28 C16.4 28 20 24.4 20 20 C20 14 12 2 12 2 Z" fill="rgba(155, 77, 67, 0.15)" stroke="#9B4D43" strokeWidth="1" data-id="element-378" data-mp="3h1tjos55n1io" />
    <path d="M8 20 C8 22 9.5 24 12 24" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" data-id="element-379" data-mp="3849krpurlhb8" />
  </svg>;
export const FamilyTree = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 40 40" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-380" data-mp="2y752w27yc808">
    <circle cx="20" cy="10" r="4" fill="#C2614F" data-id="element-381" data-mp="9bx6i2yrfoyk" />
    <circle cx="10" cy="25" r="4" fill="#6B4423" data-id="element-382" data-mp="9bdqirso7an6" />
    <circle cx="30" cy="25" r="4" fill="#6B4423" data-id="element-383" data-mp="5a1y6eiewbba" />
    <path d="M20 14 L20 20 L10 20 L10 21 M20 20 L30 20 L30 21" stroke="#C9A961" strokeWidth="1.5" data-id="element-384" data-mp="5bdbp61nsxfl" />
  </svg>;
export const SacredBackgroundDecor = ({
  className = ''
}: {
  className?: string;
}) => <div className={`absolute inset-0 pointer-events-none overflow-hidden -z-10 ${className}`} aria-hidden="true" data-id="element-385" data-mp="3rpwee5h9uo68">
    <CandleFlame className="absolute top-10 left-[5%] w-6 h-10 opacity-30 animate-float-soft" style={{
    ['--rot' as any]: '5deg',
    transform: 'rotate(5deg)'
  }} data-id="element-386" data-mp="3moyyy0nnc88f" />
    <SacredCircle className="absolute top-40 right-[8%] w-20 h-20 opacity-15 animate-float-soft" style={{
    ['--rot' as any]: '-10deg',
    transform: 'rotate(-10deg)',
    animationDelay: '1s'
  }} data-id="element-387" data-mp="3dr6iuua3owjz" />
    <OpenJournal className="absolute bottom-20 left-[8%] w-16 h-12 opacity-20 animate-float-soft" style={{
    animationDelay: '2s'
  }} data-id="element-388" data-mp="1byiak6ilnixc" />
    <FamilyTree className="absolute bottom-32 right-[6%] w-12 h-12 opacity-25 animate-float-soft" style={{
    ['--rot' as any]: '15deg',
    transform: 'rotate(15deg)',
    animationDelay: '0.5s'
  }} data-id="element-389" data-mp="1ejgb9scjrd5r" />
  </div>;